<mobile-page-part>

	<div class="info-content">Foo Bar Baz</div>

	<div>
		This is a Profile page
	</div>

</mobile-page-part>